export const RESEND_ACTIVATION_TEST_IDS = {
  submitButton: 'auth-resend-activation-submit',
} as const;
